import type { StoneMarket } from './stone-markets';

interface LocatedProperty {
  name?: string | null;
  location?: {
    countryCode?: string | null;
    country?: string | null;
    countryName?: string | null;
    region?: string | null;
  } | null;
}

/** Unknown locations must not silently become Mauritius inventory. */
export function stoneInventoryMarket(
  item: LocatedProperty
): StoneMarket | null {
  const code = item.location?.countryCode?.toLowerCase();
  if (code === 'mu') return 'mauritius';
  if (code === 'fr') return 'provence';
  const text = [
    item.name,
    item.location?.country,
    item.location?.countryName,
    item.location?.region,
  ]
    .filter(Boolean)
    .join(' ')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  if (/\b(mauritius|maurice)\b/.test(text)) return 'mauritius';
  if (/\b(provence|gordes|luberon|france|marseille|la ciotat)\b/.test(text))
    return 'provence';
  return null;
}

export const STONE_COLLECTION_PAGE_SIZE = 8;
